import { render, staticRenderFns } from "./SimilarJobsAlert.vue?vue&type=template&id=93658f1c&scoped=true&"
import script from "./SimilarJobsAlert.vue?vue&type=script&lang=ts&"
export * from "./SimilarJobsAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarJobsAlert.vue?vue&type=style&index=0&id=93658f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93658f1c",
  null
  
)

export default component.exports